import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Constant } from 'src/app/constants/constant';
import { CartService } from 'src/app/services/cart.service';
import { CommonService } from 'src/app/services/common.service';
import { ConfigServiceService } from 'src/app/services/config-service.service';
import { UserService } from 'src/app/services/user.service';
import { CommonSignInComponent } from 'src/app/shared/CommonSignIn/CommonSignIn.component';
import { SwiggyCartComponent } from '../swiggy-cart/swiggy-cart.component';

@Component({
  selector: 'calsoft-cart-icon',
  templateUrl: './cart-icon.component.html',
  styleUrls: ['./cart-icon.component.scss']
})
export class CartIconComponent implements OnInit {
  page1: string;
  url: string;
  guestLoginEnabled: string;
  userLoggedIn: boolean;
  @Input() color: any;
  @Input() data: any;
  @Input() newType = 2;
  @Input() CartName: any = '';

  disableCartIconInHeader: any = 0;
  configData: any;
  showcartpage: any;

  constructor(private router: Router,
    private userService: UserService,
    public cartServices: CartService,
    private dialog: MatDialog,
    private breakpointObserver: BreakpointObserver,
    private commonService: CommonService,
  ) { }

  ngOnInit(): void {
    const storedConfig = this.commonService.getConfigData();

    if (storedConfig) {
      this.configData = JSON.parse(storedConfig);


      // You can now use this.configData.theme, token, etc.
    } else {
      console.warn('No config data found in localStorage.');
    }
    this.url = this.router.url;
    this.guestLoginEnabled = localStorage.getItem(Constant['GUEST_LOGIN'])
    this.userLogged();
    this.getConfigData();
  }

  cart() {
    let basicAuthHeaderString = this.userService.getAuthenticatedToken();
    let username = this.userService.getAuthenticatedUser();


    if (this.guestLoginEnabled == "1" || (basicAuthHeaderString && username)) {
      if (this.showcartpage == 7 || this.showcartpage == "7") {
        this.breakpointObserver.observe([Breakpoints.Handset])
          .subscribe(result => {
            const isMobile = result.matches;
            this.dialog.open(SwiggyCartComponent, {
              width: isMobile ? '100vw' : '400px',
              height: isMobile ? '100vh' : '100%',
              maxWidth: '100vw',
              panelClass: isMobile ? 'mobile-dialog' : 'desktop-dialog',
              position: isMobile ? undefined : { right: '0', top: '0' },
              disableClose: false,
              

            });
          });
      }
      else {
    this.router.navigate(['/checkout'])

      }
  
    }
    else {
      this.page1 = "cart";
      this.loginModel();

      // this.router.navigate(['/checkout'])

    }

  }

  userLogged() {

    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };

    let basicAuthHeaderString = this.userService.getAuthenticatedToken();
    let username = this.userService.getAuthenticatedUser();

    if (basicAuthHeaderString && username) {

      this.userLoggedIn = true;
      this.cartServices.getCount();

    } else if (this.guestLoginEnabled == "1") {
      this.cartServices.getCount();
    }
    else {

      this.userLoggedIn = false;
    }
  }

  loginModel() {
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(CommonSignInComponent, {
        width: '790px',
        data: { page: this.page1, }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        this.ngOnInit();


      });

    }
    else {
      let dialogRef = this.dialog.open(CommonSignInComponent, {
        minWidth: '100vw', height: '100vh',
        data: { page: this.page1, }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        this.ngOnInit();


      });
    }

  }

  getConfigData() {

    let data = this.configData;

    this.disableCartIconInHeader = data['disableCartIconInHeader'];
    this.showcartpage = data['cartPageType'];

  }

}
